/* ============================================================================
   jd-filter-panel — behaviour for the Filter & Sort panel
   ----------------------------------------------------------------------------
   Rendered by sections/product-counter.liquid. Deliberately tiny and free of
   imports: in the native version a tick SUBMITS the form at once, so the browser
   does the navigation and the server does the filtering. Nothing here re-renders
   the grid, which is why the card carousels, the wishlist buttons, infinite scroll
   and the mobile swipe feed need no re-binding.

   The prototype fallback (jd-filter-client.js, data-jdf-mode="client") applies
   filter ticks in place instead and only navigates for sort; this file stays out
   of its change handling.

   Five jobs:
     1. open and close the dialog, and hold the page still behind it (Lenis included)
     2. native: submit on every tick, so filters apply without a confirm step
     3. note where the panel stood before such a navigation, so the inline script in
        product-counter.liquid can reopen it there, instantly
     4. drop the empty sort_by field so "Recommended" leaves a clean URL
   ============================================================================ */
(function () {
  const panel = document.querySelector('.jdf-panel');
  const toggle = document.querySelector('.jdf-toggle');
  if (!panel || !toggle) return;

  const form = panel.querySelector('.jdf-form');
  const submit = panel.querySelector('.jdf-submit');
  const REOPEN = 'jdf-reopen';

  /* ── OPEN / CLOSE ─────────────────────────────── */

  toggle.addEventListener('click', () => panel.showModal());
  panel.querySelector('.jdf-close')?.addEventListener('click', () => panel.close());

  // A <dialog> fills its own box, so a click that lands on the element itself and not on
  // any child is a click on the backdrop. (::backdrop takes no listeners of its own.)
  panel.addEventListener('click', (event) => {
    if (event.target === panel) panel.close();
  });

  // A panel reopened after a navigation skips its slide-in (see the inline script in
  // product-counter.liquid); once it closes, the next opening animates as usual.
  panel.addEventListener('close', () => panel.classList.remove('jdf-panel--instant'));

  /* ── PAGE SCROLL LOCK ─────────────────────────── */

  // The page behind stays put while the panel is open. Done the theme's own way — overflow
  // hidden on body — because snippets/smooth-scroll.liquid watches exactly that and stops
  // Lenis while it holds, as it does for the cart and menu drawers. (data-lenis-prevent on
  // the dialog is what lets the wheel scroll the panel itself.)
  //
  // Watched on the `open` attribute rather than wired to showModal/close, so every way in
  // and out is covered: the toggle, the inline reopen script in product-counter.liquid —
  // which opens the panel before this deferred file has even run — Esc, the backdrop.
  let lockedFrom = null;
  const syncScrollLock = () => {
    if (panel.open && lockedFrom === null) {
      lockedFrom = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
    } else if (!panel.open && lockedFrom !== null) {
      document.body.style.overflow = lockedFrom;
      lockedFrom = null;
    }
  };
  new MutationObserver(syncScrollLock).observe(panel, { attributes: true, attributeFilter: ['open'] });
  syncScrollLock();

  /* ── APPLY ON TICK (native) ───────────────────── */

  if (panel.dataset.jdfMode !== 'client') {
    form.addEventListener('change', () => {
      try { sessionStorage.setItem(REOPEN, String(panel.querySelector('.jdf-body').scrollTop)); } catch (error) { /* a nicety only */ }
      submit.setAttribute('data-jdf-busy', '');
      form.requestSubmit();
    });
  }

  /* ── SUBMIT ───────────────────────────────────── */

  form.addEventListener('submit', (event) => {
    // Every tick has already been applied, so the "See the N products" button has nothing
    // left to send — it just closes the panel onto the result. requestSubmit() carries no
    // submitter, which is how a tick's own navigation gets past this.
    if (event.submitter === submit) {
      event.preventDefault();
      panel.close();
      return;
    }

    // "Recommended" is the collection's own order, which is what you get by sending no
    // sort_by at all. Its radio has to carry an empty value to be selectable, so the field
    // is removed here instead — otherwise every unsorted view would carry "?sort_by=".
    const sort = form.querySelector('input[name="sort_by"]:checked');
    if (sort && sort.value === '') sort.disabled = true;
  });
})();
